<div class="d-flex m-2 mt-0 me-0 align-items-center text-grey">
  <nav aria-label="breadcrumb" class="d-flex flex-grow-1">
    <ol class="breadcrumb m-0">
      <li
        class="breadcrumb-item synchpc-primary"
        title="Go to {{ this.entityName }}"
        style="cursor: pointer;"
          (click)="navigateToEntity()"
      >
        {{ entityName }}
      </li>
      <li
        class="breadcrumb-item synchpc-primary"
        title="Current Deployment - {{ this.activeDeployment }}"
        style="color: black; cursor: pointer"
        aria-current="page"
        (click)="navigateToDeployment()"
      >
        {{ activeDeployment }}
      </li>
      <li
        *ngIf="activeProperty !== ''"
        title="{{ this.activeProperty }} of {{
          this.activeDeployment
        }} Deployment"
        class="breadcrumb-item active"
        style="color: #999999; cursor: default"
        aria-current="page"
      >
        {{ activeProperty }}
      </li>
    </ol>
  </nav>
  <div class="">
    <span style="color: var(--s-primary-color);" id="labelLastUpdate" title="{{ lastRefreshedTime | date: 'yyyy-MM-dd, HH:mm:ss'}}">Last Update : {{ lastRefreshedTime | date: 'yyyy-MM-dd, HH:mm:ss'}}</span>
  </div>
  @if (entityName == "Configurator") {
    <div class="">
      <button type="button" class="actionBtn" (click)="refresh()" placement="top auto" container="body" triggers="hover" ngbTooltip="Refresh">
        <span class="bi bi-arrow-clockwise"></span>
        <span class="button-animation">Refresh</span>
      </button>
    </div>
  }
</div>
